import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Pointer.scss'


const Pointer = ({ className, brand, onClick, id, dataScrollTo }) => {
  const rootClassName = cx(s.pointer, className, {
    [s.brand]: brand,
  })

  return (
    <button
      className={rootClassName}
      type="button"
      id={id}
      aria-label="Scroll to a next section"
      data-scroll-to={dataScrollTo}
      onClick={onClick}
    >
      <div className={s.icon} />
    </button>
  )
}

Pointer.propTypes = {
  className: PropTypes.string,
  brand: PropTypes.bool,
  id: PropTypes.string,
  dataScrollTo: PropTypes.string,
  onClick: PropTypes.func,
}


export default Pointer
